import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export interface FilterParamsItem {
  field: string;
  value: (string | number)[];
}
type ConfigStore = {
  language: string;
  updateLanguage: (data: string) => void;
};

type NonConfigStore = {
  filter: FilterParamsItem[] | null;
  updateFilter: (data: FilterParamsItem[]) => void;
};

export const useConfigStore = create<ConfigStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        language: "en",
        updateLanguage(data) {
          set((state) => {
            state.language = data;
          });
        },
      }))
    ),

    {
      name: "global-config-store",
    }
  )
);

export const useNonPersistentFilterItemsStore = create(
  immer<Partial<NonConfigStore>>((set, get) => ({
    filter: [],
    updateFilter(data) {
      set((state) => {
        state.filter = data;
      });
    },
  }))
);
